import ChangePassword from '../components/change-password/ChangePassword';
import Disbursements from '../components/disbursements/Disbursements';
import ForgotPassword from '../components/forgot-password/ForgotPassword';
import Login from '../components/login/Login';
import PayByLinkNewEdit from '../components/pay-by-link/new/PayByLinkNewEdit';
import PayByLink from '../components/pay-by-link/PayByLink';
import Payments from '../components/payments/Payments';
import ResetPassword from '../components/reset-password/ResetPassword';
import Settings from '../components/settings/Settings';
import CreateShop from '../components/shop/CreateShop';
import ShopifyAuthenticate from '../components/shopify-authenticate/ShopifyAuthenticate';
import Transfers from '../components/transfers/Transfers';
import {KeyedRouteProps} from './routes.model';
import {RoutesPaths} from './routes.paths';

export const ROUTES: KeyedRouteProps[] = [
  {
    path: RoutesPaths.ROOT,
    key: 'ROOT',
    exact: true,
    secured: true,
    component: Payments
  },
  {
    path: RoutesPaths.LOGIN,
    key: 'LOGIN',
    exact: true,
    secured: false,
    component: Login
  },
  {
    path: RoutesPaths.FORGOT_PASSWORD,
    key: 'FORGOT_PASSWORD',
    exact: true,
    secured: false,
    component: ForgotPassword
  },
  {
    path: RoutesPaths.RESET_PASSWORD,
    key: 'RESET_PASSWORD',
    exact: true,
    secured: false,
    component: ResetPassword
  },
  {
    path: RoutesPaths.CHANGE_PASSWORD,
    key: 'CHANGE_PASSWORD',
    exact: true,
    secured: true,
    component: ChangePassword
  },
  {
    path: RoutesPaths.SETTINGS,
    key: 'SETTINGS',
    exact: true,
    secured: true,
    component: Settings
  },
  {
    path: RoutesPaths.PAY_BY_LINK,
    key: 'PAY_BY_LINK',
    exact: true,
    secured: true,
    component: PayByLink
  },
  {
    path: RoutesPaths.PAY_BY_LINK_NEW,
    key: 'PAY_BY_LINK_NEW',
    exact: true,
    secured: true,
    component: PayByLinkNewEdit
  },
  {
    path: RoutesPaths.PAY_BY_LINK_EDIT,
    key: 'PAY_BY_LINK_EDIT',
    exact: true,
    secured: true,
    component: PayByLinkNewEdit
  },
  {
    path: RoutesPaths.SHOP_NEW,
    key: 'SHOP_NEW',
    exact: true,
    secured: true,
    component: CreateShop
  },
  // {
  //   path: RoutesPaths.SETTLEMENTS,
  //   key: 'SETTLEMENTS',
  //   exact: true,
  //   secured: true,
  //   component: Transfers
  // },
  {
    path: RoutesPaths.DISBURSEMENTS,
    key: 'DISBURSEMENTS',
    exact: true,
    secured: true,
    isEnableDisbursementRequired: true,
    component: Disbursements
  },
  {
    path: RoutesPaths.SHOPIFY_AUTHENTICATE,
    key: 'SHOPIFY_AUTHENTICATE',
    exact: true,
    secured: false,
    component: ShopifyAuthenticate
  }
];
